export const businessCategories = [
  "Accounting",
  "AI Apps",
  "Architecture",
  "AR/VR in Architecture",
  "Artificial Intelligence",
  "Automotive",
  "Beauty Tech",
  "Biotechnology",
  "Blockchain",
  "Childcare Service",
  "Children Services",
  "Clean Energy",
  "Clean Water Technology",
  "Clothing & Apparel",
  "Coaching",
  "Construction",
  "Consulting",
  "Consumer Electronics",
  "Copywriting",
  "Cybersecurity",
  "Dentistry",
  "Desserts",
  "Digital Marketing",
  "Digital Publishing",
  "E-commerce",
  "Education",
  "Edutainment",
  "Elderly Care",
  "Electric Vehicles",
  "Entertainment",
  "Environmental Services",
  "Event Planning",
  "Eye Wear",
  "Fashion and Apparel",
  "Finance and Banking",
  "Financial Technology (FinTech)",
  "Fitness and Wellness",
  "Food and Beverage",
  "Footwear",
  "Gaming",
  "Health and Beauty",
  "Healthcare",
  "Home Automation",
  "Home Improvement",
  "Home Appliances",
  "Homewares",
  "Hospitality",
  "Human Resources",
  "Interior Design",
  "Internet of Things (IoT)",
  "Landscaping",
  "Language Learning",
  "Legal Services",
  "Logistics and Supply Chain",
  "Manufacturing",
  "Marketing and Advertising",
  "Medical Devices",
  "Media Production",
  "Nanotechnology",
  "Nonprofit and Social Services",
  "Online Learning",
  "Outdoor Recreation",
  "Personal Development",
  "Personal Finance",
  "Pet Care",
  "Pharmaceuticals",
  "Photography",
  "Professional Services",
  "Real Estate",
  "Renewable Energy",
  "Robotics",
  "Social Impact",
  "Social Media",
  "Software Development",
  "Sports and Fitness",
  "Subscription Services",
  "Sustainable Agriculture",
  "Sustainable Fashion",
  "Technology Services",
  "Telecommunications",
  "Telemedicine",
  "Travel and Tourism",
  "Virtual Reality",
  "Video Production",
  "Wearable Technology",
  "Web Development",
];
